import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from "react";
import { Platform } from "react-native";
import { useAccessibilityContext } from "../components/AccessibilityContext";
import { Text } from "../components/Text";
import { View } from "../components/View";
import { useTheme } from "../styles";
export function useAccessibleInput(param) {
    var error = param.error, label = param.label, placeholder = param.placeholder, ref = param.ref;
    var innerRef = useRef(undefined);
    var isScreenReaderEnabled = useAccessibilityContext().isScreenReaderEnabled;
    var refCallback = useCallback(function(r) {
        innerRef.current = r;
        if (ref) {
            if (typeof ref === 'function') {
                ref(r);
            } else if (ref) {
                // eslint-disable-next-line
                ref.current = r;
            }
        }
    }, [
        ref
    ]);
    var ariaLabel = (label || placeholder || '').replace(/\*/g, '');
    return {
        'aria-label': ariaLabel,
        accessibilityLabel: ariaLabel,
        ref: refCallback,
        // https://github.com/facebook/react-native/issues/26739
        placeholder: isScreenReaderEnabled && label && placeholder !== label ? undefined : placeholder
    };
}
export function AccessibleInput(param) {
    var ariaLabel = param['aria-label'], children = param.children, error = param.error, forwardRef = param.forwardRef, hint = param.hint, hintTop = param.hintTop, label = param.label, labelColor = param.labelColor, labelSize = param.labelSize, labelLineHeight = param.labelLineHeight, labelAlign = param.labelAlign, labelWeight = param.labelWeight, labelHorizontal = param.labelHorizontal, placeholder = param.placeholder, style = param.style, testID = param.testID, required = param.required, disabled = param.disabled, onLabelLayout = param.onLabelLayout;
    var theme = useTheme().theme;
    var accessible = useAccessibleInput({
        error: error,
        label: ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : typeof label === 'string' ? label : '',
        placeholder: placeholder,
        ref: forwardRef
    });
    if (labelHorizontal === 'small') {
        labelWeight = theme.typography.small.weight;
        var _theme_typography_small_color;
        labelColor = (_theme_typography_small_color = theme.typography.small.color) !== null && _theme_typography_small_color !== void 0 ? _theme_typography_small_color : theme.color.gray400;
        labelSize = theme.typography.small.size;
    }
    return /*#__PURE__*/ _jsxs(View, {
        style: [
            style,
            disabled ? {
                opacity: 0.5,
                cursor: Platform.OS === 'web' ? 'not-allowed' : undefined
            } : undefined
        ],
        children: [
            /*#__PURE__*/ _jsxs(View, {
                row: !!labelHorizontal,
                children: [
                    label && typeof label === 'string' ? /*#__PURE__*/ _jsxs(Text, {
                        role: "none",
                        text: "",
                        style: [
                            labelHorizontal ? {
                                marginRight: 10
                            } : {
                                marginLeft: 16,
                                marginBottom: 5
                            }
                        ],
                        weight: labelWeight !== null && labelWeight !== void 0 ? labelWeight : theme.typography.label.weight,
                        color: labelColor !== null && labelColor !== void 0 ? labelColor : theme.typography.label.color,
                        size: labelSize !== null && labelSize !== void 0 ? labelSize : theme.typography.label.size,
                        lineHeight: labelLineHeight !== null && labelLineHeight !== void 0 ? labelLineHeight : theme.typography.label.lineHeight,
                        textAlign: labelAlign,
                        onLayout: onLabelLayout,
                        children: [
                            label.replace(/\*$/, ''),
                            label.endsWith('*') || required ? /*#__PURE__*/ _jsx(Text, {
                                text: " *",
                                color: theme.color.danger,
                                weight: "semibold"
                            }) : null
                        ]
                    }) : typeof label === 'function' ? /*#__PURE__*/ _jsx(View, {
                        style: {
                            marginLeft: 16
                        },
                        "aria-hidden": true,
                        onLayout: onLabelLayout,
                        children: label()
                    }) : null,
                    hintTop ? /*#__PURE__*/ _jsx(Text, {
                        text: hintTop,
                        color: theme.color.gray400,
                        size: 13,
                        style: {
                            marginLeft: 16,
                            marginBottom: 5
                        },
                        testID: "".concat(testID, "_hintTop")
                    }) : null,
                    children === null || children === void 0 ? void 0 : children(accessible)
                ]
            }),
            error ? /*#__PURE__*/ _jsx(Text, {
                text: error,
                style: {
                    marginLeft: 16,
                    marginTop: 5
                },
                color: theme.color.danger,
                size: 13,
                testID: "".concat(testID, "_error")
            }) : hint ? /*#__PURE__*/ _jsx(Text, {
                text: hint,
                color: theme.color.gray400,
                size: 13,
                style: {
                    marginLeft: 16,
                    marginTop: 5
                },
                testID: "".concat(testID, "_hint")
            }) : null
        ]
    });
}
